var map = {
	"./breeio-ident_reversed.svg": "da10",
	"./breeio-logo-animated.svg": "4197",
	"./control-left.svg": "317f",
	"./control-left_old.svg": "053f",
	"./control-right.svg": "5257",
	"./control-right_old.svg": "d1e4",
	"./heart-blue.svg": "c349",
	"./heart-pink.svg": "b2c0",
	"./icons/arrow.svg": "ff6e",
	"./icons/swipe-up.svg": "8da0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "71da";